<template>
  <b-container fluid class="mt-2 m-0 p-0">
    <b-row>
      <b-col col sm="12">
        <b-card no-body>
          <div class="card shadow">
            <div class="card-header bg-transparent p-0">
              <h3 class="float-left mb-0">
                {{ $tc("message.appointments", 2) }}
              </h3>

              <div id="back-to-calendar-btn" class="float-right app-hide">
                <b-button
                  @click="viewRendezVousFromTeleconsultations"
                  class="btn btn-primary btn-sm"
                >
                  <i class="fa fa-eye"></i>
                  {{ $t("message.view") }}
                </b-button>
                <button @click="toggleCalendar" class="btn btn-primary btn-sm">
                  <template v-if="!showCalendar">
                    <i class="fa fa-eye"></i>
                    {{ $t("message.showCalendar") }}
                  </template>
                  <template v-else>
                    <i class="fa fa-eye"></i>
                    {{ $t("message.showTable") }}
                  </template>
                </button>
              </div>

              <div class="card-body p-0 mt-5">
                <div class="card-title ml-3"></div>
                <b-container fluid class="p-0">
                  <b-row v-if="showCalendar" class="justify-content-sm-center">
                    <b-col col sm="12">
                      <b-calendar
                        v-if="!showTimeLine && !showCreateRdv"
                        @click="calendarClick"
                        v-model="selectedDay"
                        block
                        :date-info-fn="dateClass"
                      ></b-calendar>
                    </b-col>
                  </b-row>
                  <section
                    v-if="showTable"
                    class="container p-0"
                    id="appointment-table"
                  >
                    <div class="appointment-table-header my-2 mb-4">
                      <b-button
                        @click="handleOnAddAppointmentFromTable"
                        v-if="can"
                        class="mb-2"
                      >
                        <i class="fa fa-plus edit-icon"></i>
                        {{ $t("message.add") }}
                      </b-button>

                      <div class="d-inline-block ml-1 mr-5 width-270">
                        <b-input-group size="sm" class="mb-3">
                          <b-form-input
                            type="text"
                            size="sm"
                            class="p-2 h-100"
                            :placeholder="$t('message.filter') + '...'"
                            v-model="filterCriteria"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              size="sm"
                              text="Button"
                              variant="primary"
                              @click="handlerOnFilterButton"
                            >
                              Go
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                      <div class="d-inline-block ml-1 mr-5 width-270">
                        <div class="form-group">
                          <label for="exampleInputEmail1"
                            >Filtrer les rendez vous</label
                          >
                          <select
                            name="rendez_vous_manques"
                            @change="FiltreRendezVous($event)"
                            v-model="rendez_vous_manques"
                            class="form-control"
                            id="rendez_vous_manques"
                          >
                            <option value="">A venir</option>
                            <option value="rendez_vous_manques">Manqués</option>
                            <option value="rendez_vous_effectues">
                              Effectués
                            </option>
                          </select>
                        </div>
                      </div>

                      <div
                        v-if="paginationObject.numOfPages > 1"
                        class="pagination-wrapper d-inline-block"
                      >
                        <div class="pagination">
                          <a
                            href="#"
                            :class="
                              'prev page-numbers ' +
                              (paginationObject.currentPageNumber === 1
                                ? 'pagination-disabled'
                                : '')
                            "
                            @click="handlePaginationClick('prev')"
                          >
                            <i
                              aria-hidden="true"
                              class="v-icon fas fa-chevron-left"
                            ></i>
                          </a>
                          <template
                            v-for="(
                              pageNumber, key
                            ) in paginationObject.listOfPageNumber()"
                          >
                            <template
                              v-if="
                                pageNumber ===
                                paginationObject.currentPageNumber
                              "
                            >
                              <span
                                :key="key"
                                aria-current="page"
                                class="page-numbers current"
                              >
                                {{ pageNumber }}
                              </span>
                            </template>
                            <template v-else>
                              <a
                                href="#"
                                :key="key"
                                class="page-numbers"
                                @click="handlePaginationClick(pageNumber)"
                              >
                                {{ pageNumber }}
                              </a>
                            </template>
                          </template>
                          <a
                            href="#"
                            class="next page-numbers"
                            :class="
                              'next page-numbers ' +
                              (paginationObject.currentPageNumber ===
                              paginationObject.numOfPages
                                ? 'pagination-disabled'
                                : '')
                            "
                            @click="handlePaginationClick('next')"
                          >
                            <i
                              aria-hidden="true"
                              class="v-icon fas fa-chevron-right"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="row appointment-table-content p-0">
                      <div class="container-fluid p-0">
                        <template
                          v-if="
                            paginationObject.display(
                              paginationObject.currentPageNumber
                            ).length > 0
                          "
                        >
                          <div
                            v-for="(
                              appointment, key
                            ) in paginationObject.display(
                              paginationObject.currentPageNumber
                            )"
                            :key="key"
                            class="row appointment-item"
                          >
                            <div class="col-lg-3">
                              <span class="appointment-label">
                                {{ $t("message.date") }}
                              </span>
                              <h4 class="appointment-date">
                                {{ dateAppointment(appointment.date, "date") }}
                              </h4>
                              <span class="appointment-label">
                                {{ $t("message.time") }}
                              </span>
                              <h4 class="appointment-hour">
                                {{ dateAppointment(appointment.date, "hour") }}
                              </h4>
                            </div>
                            <div class="col-lg-3">
                              <span class="appointment-label">
                                {{ $t("message.nomPatient") }}
                              </span>
                              <br />
                              <b-link
                                v-if="
                                  appointment.patient.dossier_medical != null
                                "
                                :to="{
                                  name: 'medical-file',
                                  params: {
                                    file: appointment.patient.dossier_medical
                                      .slug,
                                  },
                                }"
                                >{{
                                  appointment.patient.nom +
                                  " " +
                                  appointment.patient.prenom
                                }}</b-link
                              ><br />
                              <span class="appointment-label">
                                {{ $t("message.doctorName") }}
                              </span>
                              <h4>{{ getDoctorName(appointment) }}</h4>
                            </div>
                            <div class="col-lg-3">
                              <span class="appointment-label">
                                {{ $tc("message.reasons", 2) }}
                              </span>
                              <p
                                class="appointment-motif mb-0"
                                v-html="appointment.motifs"
                              ></p>
                            </div>
                            <div class="col-lg-3">
                              <span
                                :class="
                                  'appointment-item-status ' +
                                  getStatusClass(appointment.statut)
                                "
                              >
                                <span>{{ appointment.statut }}</span>
                              </span>
                              <br />
                              <b-dropdown
                                dropdown
                                text="action"
                                variant="primary"
                                class="mt-2"
                                size="sm"
                                v-if="can"
                              >
                                <b-dropdown-item
                                  href="#"
                                  v-if="
                                    appointment.patient.dossier_medical != null
                                  "
                                  @click="
                                    onGoToMedicalFileClick(
                                      appointment.patient.dossier_medical.slug
                                    )
                                  "
                                >
                                  {{ $t("message.medicaleFolder") }}
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-if="appointment.statut != 'Effectué'"
                                  href="#"
                                  @click="EffectuerRvd(appointment)"
                                >
                                  {{ $t("message.effectuer") }}
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-if="appointment.statut != 'Effectué'"
                                  href="#"
                                  @click="ReprogrammerRdv(appointment)"
                                >
                                  {{ $t("message.reprogrammer") }}
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-if="
                                    appointment.statut != 'Manqué' &&
                                    appointment.statut != 'Effectué'
                                  "
                                  href="#"
                                  @click="
                                    handleOnAddAppointmentFromTable(
                                      'edit',
                                      appointment
                                    )
                                  "
                                >
                                  {{ $t("message.edit") }}
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-if="
                                    appointment.statut != 'Manqué' &&
                                    appointment.statut != 'Effectué'
                                  "
                                  href="#"
                                  @click="
                                    showCancelModal(appointment, 'cancel')
                                  "
                                >
                                  {{ $t("message.cancel") }}
                                </b-dropdown-item>
                                <b-dropdown-item
                                  href="#"
                                  @click="
                                    showCancelModal(appointment, 'delete')
                                  "
                                >
                                  {{ $t("message.delete") }}
                                </b-dropdown-item>
                              </b-dropdown>
                            </div>
                            <span
                              class="appointment-item-status-mobile --danger"
                              :class="
                                'appointment-item-status-mobile ' +
                                getStatusClass(appointment.statut)
                              "
                            >
                              <span class="badge badge-success">
                                {{ appointment.statut }}
                              </span>
                            </span>
                            <b-modal
                              hide-footer
                              :id="'appointment' + appointment.id"
                              size="lg"
                              :title="
                                'Rendez-vous de ' +
                                appointment.patient.nom +
                                ' ' +
                                appointment.patient.prenom
                              "
                            >
                              <p class="my-2">
                                Preprogrammation du rendez-vous du
                                {{ appointment.date }} à une date ultérieure
                              </p>
                              <b-form @submit="ReprogrammerRendezVous">
                                <b-form-group
                                  id="date_rdv"
                                  :label="$t('message.date_heure')"
                                  label-for="date_rdv"
                                >
                                  <vue-ctk-date-time-picker
                                    input-size="lg"
                                    class="border-dark"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    disabled-hours="['00','01','02','03','04','05','06','07','19','20','21','22','23']"
                                    v-model="$v.form.date.$model"
                                  ></vue-ctk-date-time-picker>
                                  <span
                                    class="custom-invalid"
                                    v-if="$v.form.date.$error"
                                  >
                                    {{ $t("message.requiredField") }}
                                  </span>
                                </b-form-group>
                                <b-button type="submit" variant="primary"
                                  >Reprogrammer</b-button
                                >
                              </b-form>
                            </b-modal>
                          </div>
                        </template>

                        <template v-else>
                          <h4>{{ $t("message.noItemToDisplay") }}</h4>
                        </template>
                      </div>
                    </div>
                    <div class="row appointment-table-footer"></div>
                  </section>
                  <section
                    class="appointment-timeline"
                    v-if="showTimeLine && showCalendar"
                  >
                    <b-button @click="hideTimeLine">
                      <i class="fa fa-reply edit-icon"></i>
                      Agenda
                    </b-button>
                    <div class="container">
                      <div class="timeline">
                        <div class="timeline-month">
                          {{ getAppointmentDate }}
                        </div>
                        <div v-for="appointments in selectedDayAppointments">
                          <div v-for="(appoimentsHour, key) in appointments">
                            <div class="timeline-section">
                              <div class="timeline-date">
                                {{ key }}
                              </div>
                              <div class="row">
                                <div
                                  class="col-sm-6"
                                  v-for="appointment in appoimentsHour"
                                >
                                  <div class="timeline-box">
                                    <div class="box-title">
                                      <i
                                        class="fa fa-asterisk text-success"
                                        aria-hidden="true"
                                      ></i>
                                      {{ heureRendezVous(appointment) }}
                                      {{
                                        appointment.patient.nom +
                                        " " +
                                        appointment.patient.prenom
                                      }}
                                    </div>
                                    <div class="box-content">
                                      <div class="box-item">
                                        <p>
                                          <strong>Nom du practicien:</strong
                                          >{{
                                            appointment.praticien.nom +
                                            " " +
                                            appointment.praticien.prenom
                                          }}
                                        </p>
                                        <p>
                                          <strong>Motif:</strong
                                          >{{ appointment.motifs }}
                                        </p>
                                      </div>
                                    </div>
                                    <div class="box-footer">
                                      <b-dropdown
                                        dropdown
                                        text="action"
                                        variant="primary"
                                        class="mt-2"
                                        size="sm"
                                      >
                                        <b-dropdown-item
                                          href="#"
                                          v-if="
                                            appointment.patient
                                              .dossier_medical != null
                                          "
                                          @click="
                                            onGoToMedicalFileClick(
                                              appointment.patient
                                                .dossier_medical.slug
                                            )
                                          "
                                        >
                                          {{ $t("message.medicaleFolder") }}
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                          href="#"
                                          @click="
                                            handleOnAddAppointmentFromTable(
                                              'edit',
                                              appointment
                                            )
                                          "
                                        >
                                          {{ $t("message.edit") }}
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                          href="#"
                                          @click="
                                            showCancelModal(
                                              appointment,
                                              'cancel'
                                            )
                                          "
                                        >
                                          {{ $t("message.cancel") }}
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                          href="#"
                                          @click="
                                            showCancelModal(
                                              appointment,
                                              'delete'
                                            )
                                          "
                                        >
                                          {{ $t("message.delete") }}
                                        </b-dropdown-item>
                                      </b-dropdown>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section v-if="showCreateRdv" class="p-0">
                    <b-button @click="hideTimeLine">
                      <i class="fa fa-reply edit-icon"></i>
                      Agenda
                    </b-button>

                    <b-form class="mt-4 p-0">
                      <div class="row p-0">
                        <div class="form-group col-md-9 col-sm-12">
                          <span class="obligatoire">*</span>
                          <label for="exampleInputEmail1">Patient</label>
                          <autocomplete
                            :search="getPatients"
                            placeholder="Rechercher le patient"
                            aria-label="Rechercher le patient"
                            :get-result-value="getValueSouscripteur"
                            @submit="choosePatient"
                          ></autocomplete>
                          <input
                            type="hidden"
                            name="patient_id"
                            id="patient_id"
                            v-model="$v.form.patient_id.$model"
                            class="form-control"
                            v-validate="'required'"
                            :class="
                              errors.has('patient_id') ? 'is-invalid' : ''
                            "
                          />
                          <small
                            id="emailHelp"
                            class="form-text text-danger"
                            v-if="$v.form.patient_id.$error"
                            >Rassurez-vous d'avoir sélectionné un patient</small
                          >
                        </div>
                        <div class="form-group col-md-3 mt-0 mt-md-5">
                          <router-link
                            :to="{
                              name: 'add-patient',
                              params: { role: 'ama' },
                            }"
                          >
                            <i class="fas fa-plus-circle edit-icon"></i>
                            <span class="nav-link-text">
                              {{ $t("message.patient") }}</span
                            >
                          </router-link>
                        </div>
                      </div>
                      <b-row>
                        <b-col md="9" v-if="ligne_temps.length > 0">
                          <span class="obligatoire">*</span>
                          <b-form-group
                            id="ligne_temps_id-group"
                            :label="$t('message.Timeline')"
                            label-for="ligne_temps_id"
                          >
                            <select
                              id="ligne_temps_id"
                              v-model="$v.form.ligne_temps_id.$model"
                              @change="clearErrorField('ligne_temps_id')"
                              class="custom-select"
                              required
                            >
                              <option value="">
                                Sélectionnez la ligne de temps
                              </option>
                              <option
                                v-for="item in ligne_temps"
                                :key="'ligne_temps' + item.id"
                                :value="item.id"
                              >
                                {{ item.motif.description }} ({{
                                  item.date_consultation
                                }})
                                {{
                                  item.affiliation == null
                                    ? ""
                                    : " | " +
                                      item.affiliation.package.description_fr
                                }}
                              </option>
                            </select>
                            <b-form-invalid-feedback
                              v-if="$v.form.ligne_temps_id.$error"
                            >
                              {{ $t("message.requiredField") }}
                            </b-form-invalid-feedback>
                            <span
                              v-if="errorshasField('ligne_temps_id')"
                              style="color: red"
                            >
                              {{ getErrorsField("ligne_temps_id") }}
                            </span>
                          </b-form-group>
                        </b-col>

                        <b-col md="9" v-if="consultations.length > 0">
                          <span class="obligatoire">*</span>
                          <b-form-group
                            id="consultation_id-group"
                            :label="$tc('message.consultations', 1)"
                            label-for="consultation_id"
                          >
                            <select
                              id="consultation_id"
                              v-model="$v.form.consultation_id.$model"
                              @change="clearErrorField('consultation_id')"
                              class="custom-select"
                              required
                            >
                              <option value="">
                                Sélectionnez la consultation
                              </option>
                              <option
                                v-for="item in consultations"
                                :key="'ligne_temps' + item.id"
                                :value="item.id"
                              >
                                {{ item.motifs }} ({{ item.etablissement }} le
                                {{ item.date_consultation }})
                              </option>
                            </select>
                            <b-form-invalid-feedback
                              v-if="$v.form.consultation_id.$error"
                            >
                              {{ $t("message.requiredField") }}
                            </b-form-invalid-feedback>
                            <span
                              v-if="errorshasField('consultation_id')"
                              style="color: red"
                            >
                              {{ getErrorsField("consultation_id") }}
                            </span>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <div class="row">
                        <div class="form-group col-md-9">
                          <span class="obligatoire">*</span>
                          <label for="etablissement_id">Etablissement</label>
                          <autocomplete
                            :search="getEtablisssements"
                            placeholder="Rechercher l'établissement"
                            aria-label="Rechercher l'établissement"
                            :get-result-value="getValueEtablissement"
                            @submit="chooseEtablissement"
                          ></autocomplete>
                          <input
                            type="hidden"
                            name="etablissement_id"
                            id="etablissement_id"
                            v-model="$v.form.etablissement_id.$model"
                            class="form-control"
                            v-validate="'required'"
                            :class="
                              errors.has('etablissement_id') ? 'is-invalid' : ''
                            "
                          />
                          <small
                            id="emailHelp"
                            class="form-text text-danger"
                            v-if="$v.form.etablissement_id.$error"
                            >Rassurez-vous d'avoir sélectionné un
                            établissement</small
                          >
                        </div>
                      </div>
                      <b-row>
                        <b-col md="9">
                          <span class="obligatoire">*</span>
                          <b-form-group
                            id="motif-group"
                            :label="$t('message.date_heure')"
                            label-for="motif"
                          >
                            <vue-ctk-date-time-picker
                              input-size="lg"
                              class="border-dark"
                              format="YYYY-MM-DD HH:mm:ss"
                              disabled-hours="['00','01','02','03','04','05','06','07','19','20','21','22','23']"
                              v-model="$v.form.date.$model"
                            ></vue-ctk-date-time-picker>
                            <span
                              class="custom-invalid"
                              v-if="$v.form.date.$error"
                            >
                              {{ $t("message.requiredField") }}
                            </span>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col md="9" sm="12">
                          <b-form-group
                            id="motif-group"
                            :label="$tc('message.reasons', 1)"
                            label-for="motif"
                          >
                            <b-form-textarea
                              id="motif"
                              v-model="$v.form.motifs.$model"
                              :state="
                                $v.form.motifs.$dirty
                                  ? !(
                                      errorshasField('motifs') ||
                                      $v.form.motifs.$error
                                    )
                                  : null
                              "
                              placeholder=""
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                              v-if="errorshasField('motifs')"
                            >
                              {{ getErrorsField("motifs") }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback
                              v-if="$v.form.motifs.$error"
                            >
                              {{ $t("message.requiredField") }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6" sm="12">
                          <b-form-group
                            id="isConsultantDoctor-group"
                            :label="$t('message.isConsultantDoctor')"
                            label-for="isConsultantDoctor"
                          >
                            <b-form-radio
                              v-model="$v.form.isConsultantDoctor.$model"
                              name="isConsultantDoctor"
                              value="true"
                              :inline="true"
                            >
                              {{ $t("message.yes") }}
                            </b-form-radio>
                            <b-form-radio
                              v-model="$v.form.isConsultantDoctor.$model"
                              name="isConsultantDoctor"
                              value="false"
                              :inline="true"
                            >
                              {{ $t("message.no") }}
                            </b-form-radio>
                            <b-form-invalid-feedback
                              v-if="errorshasField('isConsultantDoctor')"
                            >
                              {{ getErrorsField("isConsultantDoctor") }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback
                              v-if="$v.form.isConsultantDoctor.$error"
                            >
                              {{ $t("message.requiredField") }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row
                        v-if="form.isConsultantDoctor === 'false'"
                        class="mt-3"
                      >
                        <b-col md="6" sm="12">
                          <b-form-group
                            id="consultantDoctor-group"
                            :label="
                              $t('message.select') +
                              ' ' +
                              $tc('message.medecin', 1)
                            "
                            label-for="patient"
                          >
                            <b-form-radio
                              v-model="$v.form.medecinSource.$model"
                              name="medecinSource"
                              value="fromMedicasure"
                              :inline="true"
                            >
                              {{ $t("message.fromMedicasure") }}
                            </b-form-radio>
                            <b-form-radio
                              v-model="$v.form.medecinSource.$model"
                              name="medecinSource"
                              value="fromOthers"
                              :inline="true"
                            >
                              {{ $t("message.fromOthers") }}
                            </b-form-radio>
                            <!-- Options -->
                            <multiselect
                              v-if="form.medecinSource === 'fromMedicasure'"
                              v-model="$v.form.practicien_id.$model"
                              required
                              invalid-feedback="Select Doctor"
                              :options="mContributors"
                              :multiple="false"
                              placeholder="Sélectionner le medecin"
                              selectLabel="Sélectionner le medecin"
                              label="nom"
                              track-by="id"
                              :searchable="true"
                              :internal-search="true"
                              :clear-on-select="false"
                              :close-on-select="true"
                              :options-limit="30"
                              :max-height="600"
                              :show-no-results="false"
                              :hide-selected="true"
                            ></multiselect>
                            <!-- @search-change="getSouscripteurs" :loading_souscripteur="loading_souscripteur" -->
                            <!-- <v-select
                                  v-if="form.medecinSource === 'fromMedicasure'"
                                  id="consultantDoctor"
                                  class="form-control is-invalid retirerBordure"
                                  :reduce="praticien => praticien.id"
                                  v-model="$v.form.practicien_id.$model"
                                  :options="mContributors"
                                  label="nom"
                                  required /> -->

                            <!--                                                                <select-->
                            <!--                                                                        v-if="form.medecinSource === 'fromMedicasure'"-->
                            <!--&lt;!&ndash;                                                                        id="consultantDoctor"&ndash;&gt;-->
                            <!--                                                                        v-model="$v.form.practicien_id.$model"-->
                            <!--                                                                        class="form-control is-invalid border-light mt-2"-->
                            <!--                                                                >-->
                            <!--                                                                    <option v-for="item in mContributors" :value="item.id" :key="item.id">-->
                            <!--                                                                        {{ item.nom }}-->
                            <!--                                                                    </option>-->
                            <!--                                                                </select>-->

                            <b-form-input
                              id="doctorName"
                              class="mt-2"
                              v-else
                              v-model="$v.form.doctorName.$model"
                              :placeholder="$t('message.preciseDoctorName')"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row class="">
                        <b-col md="6" sm="12">
                          <b-button @click="onSubmit" variant="primary">
                            {{
                              isEdit ? $t("message.edit") : $t("message.save")
                            }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                  </section>
                </b-container>
              </div>
            </div>
            <section>
              <b-modal
                id="cancel-appointment"
                size="sm"
                header-bg-variant="danger"
                header-text-variant="light"
                :title="
                  $t('message.cancel') + ' ' + $tc('message.appointments', 1)
                "
                hide-footer
              >
                <div class="d-block text-center">
                  <h3>{{ $t("message.cancelConfirmation") }}</h3>
                </div>

                <div class="d-block float-right">
                  <b-button variant="danger" @click="handleCancelAppointment">
                    {{ $t("message.yes") }}
                  </b-button>

                  <b-button
                    variant="secondary"
                    @click="$bvModal.hide('cancel-appointment')"
                  >
                    {{ $t("message.no") }}
                  </b-button>
                </div>
              </b-modal>

              <b-modal
                id="delete-appointment"
                size="sm"
                header-bg-variant="danger"
                header-text-variant="light"
                :title="
                  $t('message.delete') + ' ' + $tc('message.appointments', 1)
                "
                hide-footer
              >
                <div class="d-block text-center">
                  <h3>{{ $t("message.deleteConfirmation") }}</h3>
                </div>

                <div class="d-block float-right">
                  <b-button
                    variant="danger"
                    @click="$bvModal.hide('delete-appointment')"
                  >
                    {{ $t("message.cancel") }}
                  </b-button>

                  <b-button
                    variant="secondary"
                    @click="handleDeleteAppointment"
                  >
                    {{ $t("message.delete") }}
                  </b-button>
                </div>
              </b-modal>
            </section>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import _ from "lodash";
import { required } from "vuelidate/lib/validators";
import SlimSelect from "slim-select";
import router from "../../router/router";
import Multiselect from "vue-multiselect";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";
import axios from "axios";
import AppConfig from "../../constants/AppConfig";

const fn = _.flow(
  (arr) =>
    _.groupBy(arr, (v) => moment(v.date).startOf("day").format("MMM Do YY")),
  (groups) =>
    _.mapValues(groups, (g) =>
      _.groupBy(g, (v) => moment(v.date).startOf("hour").format("HH:mm"))
    )
);

export default {
  name: "Appointments",
  components: {
    Autocomplete,
    Multiselect,
  },
  computed: {
    ...mapGetters([
      "rdvs",
      "patients",
      "hasAdminRole",
      "hasMedecinControleRole",
      "hasPraticienRole",
      "practitioners",
      "controlDoctors",
      "hasAssistante",
    ]),

    mPatients: function () {
      let pArray = [];

      _.forEach(this.patients, function (patient) {
        if (typeof patient.user == "object") {
          let user = patient.user;
          if (user != null) {
            if (typeof patient.dossier == "object") {
              let dossier = patient.dossier;
              let prenom =
                user.prenom != null && user.prenom ? user.prenom : "";
              prenom = prenom.toLowerCase();
              let text =
                user.nom.toUpperCase() +
                " " +
                prenom.charAt(0).toUpperCase() +
                prenom.substring(1);
              pArray.push({ text: text, value: patient.user_id });
            }
          }
        }
      });
      return pArray;
    },

    selectedDayAppointments: function () {
      let sArray = [];
      let self = this;

      if (!_.isNull(self.selectedDay)) {
        sArray = _.filter(self.mAppointments, function (appointment) {
          return (
            self.selectedDay == moment(appointment.date).format("YYYY-MM-DD")
          );
        });
      }
      sArray = _.orderBy(sArray, ["date"], ["asc"]);
      return fn(sArray);
    },

    mAppointments: function () {
      let aArray = [];
      let self = this;
      _.forEach(self.rdvs, function (rdv) {
        let existe = _.find(aArray, function (a) {
          a.id == rdv.id;
        });
        if (_.isUndefined(existe)) {
          aArray.push(rdv);
        }
      });

      let todayArray = [];
      let afterArray = [];
      let beforeArray = [];

      todayArray = _.filter(self.rdvs, function (rdv) {
        return (
          moment(rdv.date).format("YYYY-MM-DD") ===
          moment().format("YYYY-MM-DD")
        );
      });

      todayArray = todayArray.sort(
        (a, b) => moment(b.date).format("X") - moment(a.date).format("X")
      );

      afterArray = _.filter(self.rdvs, function (rdv) {
        return moment(moment(rdv.date).format("YYYY-MM-DD")).isAfter(
          moment(moment().format("YYYY-MM-DD"))
        );
      });

      afterArray = afterArray.sort(
        (a, b) => moment(a.date).format("X") - moment(b.date).format("X")
      );

      beforeArray = _.filter(self.rdvs, function (rdv) {
        return moment(moment(rdv.date).format("YYYY-MM-DD")).isBefore(
          moment(moment().format("YYYY-MM-DD"))
        );
      });
      beforeArray = beforeArray.sort(
        (a, b) => moment(b.date).format("X") - moment(a.date).format("X")
      );

      aArray = todayArray.concat(afterArray, beforeArray);
      return aArray;

      // Sort the array by creating date
      // return aArray.sort((a, b) => moment(b.date).format("X") - moment(a.date).format("X"));
    },

    getAppointmentDate: function () {
      if (!_.isNull(this.selectedDay)) {
        return moment(this.selectedDay).format("D, dddd");
      }
      return "";
    },
    can: function () {
      return (
        this.hasAdminRole ||
        this.hasMedecinControleRole ||
        this.hasPraticienRole ||
        this.hasAssistante
      );
    },

    mPractitioners: function () {
      let pArray = [];

      _.forEach(
        _.orderBy(this.practitioners, ["created_at"], ["desc"]),
        function (practitioner) {
          let p = {};
          if (
            typeof practitioner.user == "object" &&
            !_.isNull(practitioner.user)
          ) {
            let prenom =
              practitioner.user.prenom != "null" &&
              !_.isNull(practitioner.user.prenom)
                ? practitioner.user.prenom
                : "";
            prenom = prenom.toLowerCase();
            p.nom =
              practitioner.user.nom.toUpperCase() +
              " " +
              prenom.charAt(0).toUpperCase() +
              prenom.substring(1);
            p.id = practitioner.user.id;
            if (p.nom.length > 0) {
              pArray.push(p);
            }
          }
        }
      );

      return pArray;
    },

    mDoctors: function () {
      let dArray = [];

      _.forEach(
        _.orderBy(this.controlDoctors, ["created_at"], ["desc"]),
        function (doctor) {
          let d = {};
          if (typeof doctor.user == "object" && !_.isNull(doctor.user)) {
            let prenom = doctor.user.prenom != null ? doctor.user.prenom : "";
            prenom = prenom.toLowerCase();
            d.nom =
              doctor.user.nom.toUpperCase() +
              " " +
              prenom.charAt(0).toUpperCase() +
              prenom.substring(1);
            d.id = doctor.user.id;

            if (d.nom.length > 0) {
              dArray.push(d);
            }
          }
        }
      );

      return dArray;
    },

    mContributors: function () {
      let cArray = [];
      return cArray.concat(this.mDoctors, this.mPractitioners);
    },
  },
  data() {
    return {
      form: {
        ligne_temps_id: "",
        date: "",
        motifs: "",
        patient_id: "",
        consultation_id: "",
        etablissement_id: "",
        affiliation_id: "",
        isConsultantDoctor: "true",
        practicien_id: "",
        doctorName: "",
        medecinSource: "fromMedicasure",
        // this field is hidden and its value if filled automatically
        slug: "",
      },
      selectedDay: "",
      filterCriteria: "",
      showTable: true,
      showCalendar: false,
      showTimeLine: false,
      yourValue: null,
      showCreateRdv: false,
      isEdit: false,
      previousStateChoice: "",
      tmpYear: new Date().getFullYear(),
      paginationObject: {},
      filterAppointment: [],
      affiliations: [],
      ligne_temps: [],
      consultations: [],
      appointment: {},
      appointmentToDeleteOrToCancel: null,
      rendez_vous_manques: "",
    };
  },

  watch: {
    selectedDay: function (newDate, oldDate) {
      let self = this;
      let isRdvDate = _.find(self.mAppointments, function (appointment) {
        return newDate == moment(appointment.date).format("YYYY-MM-DD");
      });
      if (self.can) {
        if (!_.isUndefined(isRdvDate)) {
          this.showTimeLine = true;
        } else if (!_.isNull(newDate)) {
          this.previousStateChoice = this.showCalendar ? "calendar" : "table";
          this.showCreateRdv = true;
        }
      }
    },
    mAppointments: function (newValue, oldValue) {
      this.paginationObject = this.Pagination(newValue, 10);
    },
    filterCriteria: function (newValue, oldValue) {
      this.handleFilter(newValue);
    },
  },

  methods: {
    viewRendezVousFromTeleconsultations() {
      // console.log(this.file.slug);
      this.$router.push({ name: "more-appointments" });
    },
    FiltreRendezVous: function (event) {
      this.getAppointmentLists();
    },
    onGoToMedicalFileClick(slug) {
      router.push({ name: "medical-file", params: { file: slug } });
    },
    getPatients(input) {
      return new Promise((resolve) => {
        if (input.length < 3) {
          return resolve([]);
        }
        fetch(AppConfig.apiUrl + "/search/patients/" + input, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("ms-token"),
          },
        })
          .then((res) => res.json())
          .then((res) => {
            resolve(res.patients);
          })
          .catch((error) => {
            console.log("error ", error);
          });
      });
    },

    getEtablisssements(input) {
      return new Promise((resolve) => {
        if (input.length < 2) {
          return resolve([]);
        }
        fetch(AppConfig.apiUrl + "/search/etablissements/" + input, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("ms-token"),
          },
        })
          .then((res) => res.json())
          .then((res) => {
            resolve(res.etablissements);
          })
          .catch((error) => {
            console.log("error ", error);
          });
      });
    },
    getValueEtablissement(result) {
      return result.name;
    },
    chooseEtablissement(result) {
      this.form.etablissement_id = result.id;
    },
    getValueSouscripteur(result) {
      return (
        result.user.nom +
        " " +
        result.user.prenom +
        " (" +
        result.user.email +
        ")"
      );
    },
    choosePatient(result) {
      this.form.patient_id = result.user_id;
      if (this.form.patient_id != "") {
        axios
          .get(`${AppConfig.apiUrl}/affiliations/${this.form.patient_id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("ms-token")}`,
            },
          })
          .then((res) => {
            this.ligne_temps = res.data.ligne_temps;
            this.form.ligne_temps_id = "";
            this.form.affiliation_id = "";
            // console.log('res.data.affiliations ', res.data.ligne_temps)
          })
          .catch((error) => {
            console.log("error ", error);
          });
      }
    },
    filterResult(sArray, mArray) {
      if (this.filteredValue == 1) {
        mArray = sArray;
      } else if (this.filteredValue == 2) {
        //Non archivés
        mArray = _.filter(mArray, function (medecine) {
          return _.isNull(medecine.archievedAt);
        });
      } else if (this.filteredValue == 3) {
        //Non transmis
        mArray = _.filter(mArray, function (medecine) {
          return _.isNull(medecine.passedAt);
        });
      } else if (this.filteredValue == 4) {
        //Archivés
        mArray = _.filter(mArray, function (medecine) {
          return !_.isNull(medecine.archievedAt);
        });
      } else if (this.filteredValue == 5) {
        //Transmis
        mArray = _.filter(mArray, function (medecine) {
          return !_.isNull(medecine.passedAt);
        });
      }
      return mArray;
    },
    dateAppointment(date, type) {
      switch (type) {
        case "date":
          return moment(date).format("ddd, Do MMM YYYY");
        case "hour":
          return moment(date).format("HH:mm");
      }
    },
    getStatusClass(status) {
      if (status === "Reprogrammé" || status === "Reprogrammer")
        return "--warning";
      else if (
        status === "Annulé" ||
        status === "Annuler" ||
        status === "Manqué"
      )
        return "--danger";
      else return "--success";
    },
    getDoctorName(appointment) {
      if (appointment.praticien) {
        return (
          appointment.praticien.nom +
          " " +
          (_.isNull(appointment.praticien.prenom)
            ? ""
            : appointment.praticien.prenom)
        );
      } else return appointment.nom_medecin;
    },
    toggleCalendar() {
      event.preventDefault();
      this.showCalendar = !this.showCalendar;
      this.showTable = !this.showTable;
      // this.mAppointments = [];
    },
    handleOnAddAppointmentFromTable(action = null, appointment = null) {
      this.showCreateRdv = true;
      this.timeline = false;
      this.previousStateChoice = this.showCalendar ? "calendar" : "table";
      this.showCalendar = false;
      this.showTable = false;
      if (action === "edit") {
        this.form.date = appointment.date;
        this.form.etablissement_id = appointment.etablissement.name;
        this.form.motifs = appointment.motifs;
        this.form.patient_id =
          appointment.patient.nom + " " + appointment.patient.prenom;
        this.form.slug = appointment.slug;

        // Add additional data
        if (appointment.praticien) {
          let practicien = null;
          if (
            this.hasPraticienRole ||
            this.hasMedecinControleRole ||
            this.hasAssistante
          ) {
            practicien = JSON.parse(localStorage.getItem("user"))["id"];
          }

          this.form.practicien_id = appointment.praticien_id;
          if (practicien == appointment.praticien_id) {
            this.form.isConsultantDoctor = "true";
          } else {
            this.form.isConsultantDoctor = "false";
            this.form.medecinSource = "fromMedicasure";
          }
        } else {
          this.form.isConsultantDoctor = "false";
          this.form.medecinSource = "fromOthers";
          this.form.doctorName = appointment.nom_medecin;
        }
        this.isEdit = true;
      }
    },

    ReprogrammerRdv(appointment) {
      this.appointment = appointment;
      this.form.date = appointment.date;

      this.$bvModal.show("appointment" + appointment.id);
    },

    ReprogrammerRendezVous(event) {
      event.preventDefault();
      const args = {
        id: this.appointment.id,
        patient_id: this.appointment.patient_id,
        praticien_id: "" + this.appointment.praticien_id,
        date: moment(this.form.date).format("YYYY-MM-DD HH:mm"),
        statut: "Reprogrammé",
      };

      const successMessage = this.$i18n.t("message.appointmentUpdated");
      const errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };

      const payload = { args, errorMessages, successMessage };
      payload.rdv = this.appointment.slug;
      this.$store.dispatch("updateAppointment", payload).then(() => {
        this.$bvModal.hide("appointment" + this.appointment.id);
        this.rendez_vous_manques = "";
        this.getAppointmentLists();
      });
    },

    EffectuerRvd(appointment) {
      const args = {
        id: appointment.id,
        patient_id: appointment.patient_id,
        praticien_id: "" + appointment.praticien_id,
        date: moment(appointment.date).format("YYYY-MM-DD HH:mm"),
        statut: "Effectué",
      };

      const successMessage = this.$i18n.t("message.appointmentUpdated");
      const errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };

      const payload = { args, errorMessages, successMessage };
      payload.rdv = appointment.slug;

      this.$store.dispatch("updateAppointment", payload).then(() => {
        this.rendez_vous_manques = "rendez_vous_effectues";
        this.getAppointmentLists();
      });
    },

    heureRendezVous(appointment) {
      return moment(appointment.date).format("HH:mm");
    },

    showCancelModal(appointment, action) {
      event.preventDefault();
      this.appointmentToDeleteOrToCancel = appointment;
      this.$bvModal.show(
        action === "cancel" ? "cancel-appointment" : "delete-appointment"
      );
    },

    onSubmit: function () {
      event.preventDefault();
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const args = {};

        // Perform task about practicien or medecine name

        if (this.form.isConsultantDoctor === "true") {
          let practicien = null;
          if (
            this.hasPraticienRole ||
            this.hasMedecinControleRole ||
            this.hasAssistante
          ) {
            practicien = JSON.parse(localStorage.getItem("user"))["id"];
          }
          // console.log("this.form",practicien);
          args.praticien_id = practicien;
        } else if (this.form.medecinSource === "fromMedicasure") {
          args.praticien_id = this.form.practicien_id.id;
        } else {
          args.praticien_id = this.form.doctorName;
        }

        // Parse it to string
        args.praticien_id = "" + args.praticien_id;
        args.ligne_temps_id = this.form.ligne_temps_id;
        args.consultation_id = this.form.consultation_id;
        args.etablissement_id = this.form.etablissement_id;

        args.date = moment(this.form.date).format("YYYY-MM-DD HH:mm");
        args.patient_id = this.form.patient_id;

        args.affiliation_id = this.form.affiliation_id;

        args.motifs = this.form.motifs;
        args.statut = this.isEdit ? "Reprogrammé" : "Programmé";

        const successMessage = this.$i18n.t(
          this.isEdit ? "message.appointmentUpdated" : "message.appointmentMade"
        );
        const errorMessages = {
          generic: this.$i18n.t("message.genericError"),
          error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
        };

        const actionToPerform = this.isEdit
          ? "updateAppointment"
          : "makeAppointment";

        const payload = { args, errorMessages, successMessage };
        if (this.isEdit) {
          payload.rdv = this.form.slug;
        }
        // console.log("args",args);

        // console.log("this.form",this.form);

        this.$store.dispatch(actionToPerform, payload).then(() => {
          this.getAppointmentLists();
          this.$v.form.patient_id.$model = null;
          this.$v.form.etablissement_id.$model = null;
          this.$v.form.date.$model = null;
          this.$v.form.ligne_temps_id.$model = null;
          this.$v.form.consultation_id.$model = null;
          this.$v.form.motifs.$model = null;
          this.$v.form.medecinSource.$model = "fromMedicasure";
          this.$v.form.isConsultantDoctor.$model = "true";
          this.$v.form.doctorName.$model = "";
          this.$v.form.$reset();
          this.form.slug = "";
          this.isEdit = false;
          this.showCreateRdv = false;
          if (this.previousStateChoice === "calendar") {
            this.showCalendar = true;
            this.showTimeLine = false;
          } else {
            this.showTable = true;
            this.showTimeLine = false;
          }
        });
      }
    },

    handleDeleteAppointment() {
      event.preventDefault();

      const successMessage = this.$i18n.t("message.appointmentDeleted");
      const errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };

      const payload = {
        args: {},
        rdv: this.appointmentToDeleteOrToCancel.slug,
        errorMessages,
        successMessage,
      };

      this.$store.dispatch("deleteAppointment", payload).then(() => {
        this.getAppointmentLists();
        this.$bvModal.hide("delete-appointment");
        this.appointmentToDeleteOrToCancel = null;
        if (this.previousStateChoice === "calendar") {
          this.showCalendar = true;
          this.showTimeLine = false;
        } else {
          this.showTable = true;
          this.showTimeLine = false;
        }
      });
    },

    handleCancelAppointment() {
      event.preventDefault();
      const appointment = this.appointmentToDeleteOrToCancel;
      if (appointment) {
        const args = {};
        args.date = moment(appointment.date).format("YYYY-MM-DD HH:mm");
        args.patient_id = appointment.patient_id;
        args.etablissement_id = appointment.etablissement_id;
        args.motifs = appointment.motifs;
        args.statut = "Annulé";
        if (!appointment.nom_medecin || appointment.nom_medecin === "")
          args.praticien_id = "" + appointment.praticien_id;
        else args.praticien_id = appointment.nom_medecin;

        const successMessage = this.$i18n.t("message.appointmentCanceled");
        const errorMessages = {
          generic: this.$i18n.t("message.genericError"),
          error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
        };

        const payload = {
          args,
          slug: appointment.slug,
          errorMessages,
          successMessage,
        };

        this.$store.dispatch("cancelAppointment", payload).then(() => {
          this.$bvModal.hide("cancel-appointment");
          this.getAppointmentLists();
          this.appointmentToDeleteOrToCancel = null;
        });
      }
    },

    /*     getPatients: function() {
      this.$store.dispatch('getPatients', { args: {} });
    }, */

    hideTimeLine() {
      this.showTimeLine = false;
      this.showCreateRdv = false;
      this.showTable = false;
      this.previousStateChoice === "calendar"
        ? (this.showCalendar = true)
        : (this.showTable = true);
      this.selectedDay = null;
    },

    calendarClick() {
      let self = this;
      let isRdvDate = _.find(self.mAppointments, function (appointment) {
        return (
          self.selectedDay == moment(appointment.date).format("YYYY-MM-DD")
        );
      });
      if (!_.isUndefined(isRdvDate)) {
        this.showTimeLine = true;
      } else {
        this.showTimeLine = false;
      }
    },

    dateClass(ymd, date) {
      let self = this;
      let rdvDate = 0;
      let styleDate = _.find(self.mAppointments, function (appointment) {
        return ymd == moment(appointment.date).format("YYYY-MM-DD");
      });
      let day = date.getDate();
      if (!_.isUndefined(styleDate)) {
        rdvDate = moment(styleDate.date).date();
      }

      return day == rdvDate && rdvDate != 0 ? "table-info" : "";
    },

    getAppointmentLists: function () {
      let args = {
        date_debut: moment().toDate(),
        nbre: 1,
        rendez_vous_manques: this.rendez_vous_manques,
      };
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };

      this.$store.dispatch("getAppointments", { args, errorMessages });
    },

    getDoctors() {
      let args = {
        offset: this.offset,
        limit: this.limit,
      };
      if (
        this.hasPraticienRole ||
        this.hasMedecinControleRole ||
        this.hasAdminRole ||
        this.hasAssistante
      ) {
        this.$store.dispatch("getControlDoctors", { args: args });
      }
    },

    getPractitioners() {
      let args = {
        offset: this.offset,
        limit: this.limit,
      };
      if (
        this.hasPraticienRole ||
        this.hasMedecinControleRole ||
        this.hasAdminRole ||
        this.hasAssistante
      ) {
        this.$store.dispatch("getPractitioners", { args: args });
      }
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return "";
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      if (field == "affiliation_id" && this.form.affiliation_id != "") {
        axios
          .get(
            `${AppConfig.apiUrl}/affiliations/${this.form.affiliation_id}/ligne-de-temps`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("ms-token")}`,
              },
            }
          )
          .then((res) => {
            this.ligne_temps = res.data.ligne_temps;
            this.form.ligne_temps_id = "";
            this.form.consultation_id = "";
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else if (field == "ligne_temps_id" && this.form.ligne_temps_id != "") {
        axios
          .get(
            `${AppConfig.apiUrl}/consultation_generale/ligne-temps/${this.form.ligne_temps_id}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("ms-token")}`,
              },
            }
          )
          .then((res) => {
            this.consultations = res.data;
          })
          .catch((error) => {
            console.log("error ", error);
          });
        let ligne_temps = this.ligne_temps.find(
          (item) => item.id == this.form.ligne_temps_id
        );
        this.form.affiliation_id =
          ligne_temps.affiliation_id == null ? "" : ligne_temps.affiliation_id;
        this.form.consultation_id = "";
      }

      this.$store.dispatch("clearErrorField", { field });

      this.getErrorsField(field);
    },

    Pagination(pageEleArr, numOfEleToDisplayPerPage) {
      // Create an object to easily manipulate property linked
      const result = {};
      // Added a new property to hold the list of elements
      result.pageEleArr = pageEleArr;

      // Added a new property to hold the number of item to display per page
      result.numOfEleToDisplayPerPage = numOfEleToDisplayPerPage;

      // Added a new property to hold the total number of items
      result.elementCount = result.pageEleArr.length;

      // Added a new property to hold the number of items to display per page
      result.numOfPages = Math.ceil(
        result.elementCount / result.numOfEleToDisplayPerPage
      );

      // Set the current page number to 1
      result.currentPageNumber = 1;

      result.listOfPageNumber = function () {
        const listOfPageNumber = [];
        for (let i = 1; i < result.numOfPages + 1; i++) {
          listOfPageNumber.push(i);
        }
        return listOfPageNumber;
      };

      // Function to get the various list item per page
      // Return Array[Array]
      const pageElementsArr = function (arr, eleDispCount) {
        const arrLen = arr.length;
        const noOfPages = Math.ceil(arrLen / eleDispCount);
        const pageArr = [];

        let perPageArr = [],
          index = 0,
          condition = 0,
          remainingEleInArr = 0;

        for (let i = 0; i < noOfPages; i++) {
          if (i === 0) {
            index = 0;
            condition = eleDispCount;
          }
          // Create an list of items of a page
          for (let j = index; j < condition && j < arrLen; j++) {
            perPageArr.push(arr[j]);
          }

          // insert that list into then global list
          pageArr.push(perPageArr);

          if (i === 0) {
            remainingEleInArr = arrLen - perPageArr.length;
          } else {
            remainingEleInArr = remainingEleInArr - perPageArr.length;
          }

          if (remainingEleInArr > 0) {
            if (remainingEleInArr > eleDispCount) {
              index = index + eleDispCount;
              condition = condition + eleDispCount;
            } else {
              index = index + perPageArr.length;
              condition = condition + remainingEleInArr;
            }
          }
          perPageArr = [];
        }
        return pageArr;
      };

      // Main method to get a list of a particular page
      result.display = function (pageNo) {
        // If the asked page is not in the range of available pages
        if (pageNo > result.numOfPages || pageNo <= 0) {
          return [];
        } else {
          // Get the total list
          const totalList = pageElementsArr(
            result.pageEleArr,
            result.numOfEleToDisplayPerPage
          );

          // Return the list of the pageNo
          return totalList[[pageNo - 1]];
        }
      };

      // Return the pagination object
      return result;
    },

    handlePaginationClick(action) {
      event.preventDefault();

      // If we want to go to the previous page
      if (action === "prev") {
        if (this.paginationObject.currentPageNumber - 1 >= 1)
          this.paginationObject.currentPageNumber =
            this.paginationObject.currentPageNumber - 1;
      }

      // If we want to go to the next page
      else if (action === "next") {
        if (
          this.paginationObject.currentPageNumber + 1 <=
          this.paginationObject.numOfPages
        )
          this.paginationObject.currentPageNumber =
            this.paginationObject.currentPageNumber + 1;
      }

      // If we want to go to a particular page
      else {
        const numberOfPageToGoTo = Number(action);
        if (
          numberOfPageToGoTo <= this.paginationObject.numOfPages &&
          numberOfPageToGoTo >= 1
        )
          this.paginationObject.currentPageNumber = numberOfPageToGoTo;
      }
    },

    handlerOnFilterButton() {
      event.preventDefault();
      this.handleFilter(this.filterCriteria);
    },

    handleFilter(value) {
      if (value) {
        const newAppointments = this.mAppointments.filter((app) => {
          let result = false;
          if (app.motifs) {
            result =
              result || app.motifs.toLowerCase().includes(value.toLowerCase());
          }

          if (app.patient.nom) {
            result =
              result ||
              app.patient.nom.toLowerCase().includes(value.toLowerCase());
          }

          if (app.patient.prenom) {
            result =
              result ||
              app.patient.prenom.toLowerCase().includes(value.toLowerCase());
          }

          if (app.date && this.dateAppointment(app.date, "date")) {
            result =
              result ||
              this.dateAppointment(app.date, "date")
                .toLowerCase()
                .includes(value.toLowerCase());
          }

          if (app.date && this.dateAppointment(app.date, "hour")) {
            result =
              result ||
              this.dateAppointment(app.date, "hour")
                .toLowerCase()
                .includes(value.toLowerCase());
          }

          return result;
        });

        this.paginationObject = this.Pagination(newAppointments, 2);
      } else {
        this.paginationObject = this.Pagination(this.mAppointments, 2);
      }
    },
  },

  validations() {
    return {
      form: {
        date: {
          required,
        },

        patient_id: {
          required,
        },

        practicien_id: {},
        ligne_temps_id: {},
        consultation_id: {},
        affiliation_id: {},
        etablissement_id: {
          required,
        },

        motifs: {
          // required
        },

        isConsultantDoctor: {
          required,
        },

        medecinSource: {},

        doctorName: {},
      },
    };
  },
  mounted() {
    //this.getTimelines();
    // Récupérer les patients
    //this.getPatients();

    this.getAppointmentLists();

    // Fetch control doctor list
    this.getDoctors();

    // Fetch practitioner list
    this.getPractitioners();

    // this.launchPagination();
  },
};
</script>
<style scoped>
@import url("~slim-select/dist/slimselect.min.css");
</style>
